import { FcDeleteDatabase } from "react-icons/fc";

export default function NotFound() {
    return (
        <div className="flex flex-col items-center justify-center py-8">
            <FcDeleteDatabase className="text-4xl mb-4" />
            <div className="text-center">Data tidak ada</div>
        </div>
    )
}